module.exports = {"id":"dp4_1l3q1","text":"Protecting Devices","instructions":"Why is staying up to date with cybersecurity practices important?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.1","questionType":"PickOne","random":true,"options":[{"id":"dp4_1l3q1-a1","text":"Threats change over time","score":3.7},{"id":"dp4_1l3q1-a2","text":"Devices slow down otherwise","score":1.3},{"id":"dp4_1l3q1-a3","text":"Laws require daily updates","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.1/l3q1.json
// module id = 1207
// module chunks = 41